import { YupSchema } from 'services/yup/types'
import { catalogItemBaseShapeVS } from './catalogItemBase'
import { yupString } from 'services/yup/custom-schemas/string'
import { yupArray } from 'services/yup/custom-schemas/array'
import { ProductCommon } from 'services/api/entities/catalog/productCommon/types/internal/productCommon-models'

export const productCommonVS: YupSchema<ProductCommon> =
  catalogItemBaseShapeVS.shape({
    description: yupString().required(),
    facetCodes: yupArray(),
    facets: yupArray(),
    images: yupArray(),
  })
